import CloseButton from './buttons/CloseButton'
import classNames from 'classnames'
import $ from 'jquery'
import { findDOMNode } from 'react-dom'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

const handlerProps = ['onShow', 'onShown', 'onHide', 'onHidden']
const modalEvent = {
  onShow: 'show.bs.modal',
  onShown: 'shown.bs.modal',
  onHide: 'hide.bs.modal',
  onHidden: 'hidden.bs.modal'
}

export default class Modal extends Component {
  static propTypes = {
    backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
    className: PropTypes.string,
    footer: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
    header: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
    isOpen: PropTypes.bool.isRequired,
    keyboard: PropTypes.bool,
    onCloseClick: PropTypes.func.isRequired,
    onHidden: PropTypes.func,
    onHide: PropTypes.func,
    onShow: PropTypes.func,
    onShown: PropTypes.func,
    remote: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    show: PropTypes.bool,
    showCloseButton: PropTypes.bool
  }

  static defaultProps = {
    backdrop: true,
    keyboard: true,
    show: false,
    remote: false,
    showCloseButton: true
  }

  componentDidMount() {
    const { backdrop, isOpen, keyboard, show, remote, className } = this.props

    this.$modal = $(findDOMNode(this))

    this.$modal.modal({
      backdrop: backdrop,
      keyboard: keyboard,
      show: show,
      remote: remote
    })

    handlerProps.forEach(prop => {
      if (this.props[prop]) {
        this.$modal.on(modalEvent[prop], this.props[prop])
      }
    })

    if (isOpen) {
      this.show()
    }
  }

  componentWillReceiveProps({ isOpen }) {
    isOpen ? this.show() : this.hide()
  }

  componentWillUnmount() {
    handlerProps.forEach(prop => {
      if (this.props[prop]) {
        this.$modal.off(modalEvent[prop], this.props[prop])
      }
    })
  }

  show() {
    this.$modal.modal('show')
  }

  hide() {
    this.$modal.modal('hide')
  }

  renderCloseButton() {
    const { showCloseButton, onCloseClick } = this.props

    if (showCloseButton) {
      return <CloseButton onClick={onCloseClick} />
    }
  }

  renderHeader() {
    const { header } = this.props

    if (header) {
      return (
        <div className="modal-header">
          {this.renderCloseButton()}
          {header}
        </div>
      )
    }
  }

  renderFooter() {
    const { footer } = this.props

    if (footer) {
      return <div className="modal-footer">{footer}</div>
    }
  }

  render() {
    const { children, className, header } = this.props
    const classes = classNames('modal', 'fade', className)

    return (
      <div className={classes}>
        <div className="modal-dialog">
          <div className="modal-content">
            {this.renderHeader()}
            <div className="modal-body">
              {!header && this.renderCloseButton()}
              {children}
            </div>
            {this.renderFooter()}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/Modal.js